import { Provider } from '@angular/core';
import { HashMap, Translation, TRANSLOCO_SCOPE } from '@jsverse/transloco';

import { AppLanguageListService } from './app-language-list.service';
import { extractLabels } from './extractLabels';

export type TranslocoImportFn = (lang: string) => Promise<unknown>;

function inlineScopeLoader(
	appLanguageListService: AppLanguageListService,
	scope: string,
	importer: TranslocoImportFn
): HashMap {
	return appLanguageListService.getLanguageList().reduce<HashMap>((all, next) => {
		all[next.id] = async (): Promise<Translation> => {
			let rawImport: unknown;
			try {
				rawImport = await importer(`${next.id}.json`);
			} catch {
				// eslint-disable-next-line no-console
				console.error(`Failed to load "${next.id}" labels for local scope ${scope}`);
				rawImport = {};
			}
			const imported = <Translation>rawImport;
			// Workaround for json imports being placed under a "default" property
			// eslint-disable-next-line dot-notation
			const rawLabels = <Translation>(imported['default'] ?? imported);
			return extractLabels(rawLabels);
		};
		return all;
	}, {});
}

export function provideInlineScope(scope: string, importer: TranslocoImportFn): Provider {
	return {
		provide: TRANSLOCO_SCOPE,
		useFactory: (appLanguageListService: AppLanguageListService) => ({
			scope,
			loader: inlineScopeLoader(appLanguageListService, scope, importer)
		}),
		deps: [AppLanguageListService]
	};
}
